declare namespace $ {

	type $mol_text__text_bog_pazzle_board_tile_1 = $mol_type_enforce<
		ReturnType< $bog_pazzle_board_tile['label'] >
		,
		ReturnType< $mol_text['text'] >
	>
	export class $bog_pazzle_board_tile extends $rise_drag_view {
		Number( ): $mol_text
		rows( ): number
		columns( ): number
		piece( ): number
		slot( ): number
		image_uri( ): string
		playable( ): boolean
		locked( ): boolean
		selected( ): boolean
		label( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=tile.view.tree.d.ts.map